import {DataSection} from '@cypro/ui/components/ui/data-section'
import {usePatientContext} from '@/shared/contexts/patient-context'
import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {PatientHistoryTimeline} from '../patient_history_timeline'

export function HistoryTab() {
  const {t} = useTranslate('common')
  const {history} = usePatientContext()

  return (
    <Tabs.Content value="history">
      <DataSection label={t('version_history')}>
        <PatientHistoryTimeline activities={history || []} />
      </DataSection>
    </Tabs.Content>
  )
}
